import { defineAbility } from '@casl/ability' // eslint-disable-line import/no-extraneous-dependencies
import { config } from 'configs'

const useAbility = (allowedModules, permissions) =>
  defineAbility((can) => {
    const { actions, components, organizationAdmin } = config
    const {
      organizationDashboard,
      organizationDetails,
      organizationSubscription,
      organizationPayment,
      organizationReport,
      organizationBusinessRequests,
      organizationB2BProgram,
      organizationCommunity,
    } = components
    // Organization Components
    const organizationComponentsList = [
      organizationDashboard,
      organizationDetails,
      organizationSubscription,
      organizationPayment,
      organizationReport,
      organizationBusinessRequests,
      organizationB2BProgram,
      organizationCommunity,
    ]

    const { read, edit, anything } = actions

    const isAllowedTo = (action, on) => {
      let isAllowed = false
      switch (action) {
        case read:
          if (permissions?.includes(`${on}Reader`)) {
            isAllowed = true
          }
          break
        case edit:
          if (permissions?.includes(`${on}Editor`)) {
            isAllowed = true
          }
          break
        case anything:
          if (
            permissions?.includes(`${on}Reader`) ||
            permissions?.includes(`${on}Editor`)
          ) {
            isAllowed = true
          }
          break
        default:
          break
      }
      return isAllowed
    }

    let doAnythingOnOrganizationComponents = false
    if (permissions?.includes(organizationAdmin)) {
      doAnythingOnOrganizationComponents = true
      can(read, organizationAdmin)
      can(edit, organizationAdmin)
      Object.keys(components).forEach((key) => {
        const isSubscriptionActiveAndOrganizationComponent =
          allowedModules.includes(organizationAdmin) &&
          organizationComponentsList.includes(components[key])

        if (
          allowedModules.includes(components[key]) ||
          isSubscriptionActiveAndOrganizationComponent
        ) {
          can(read, components[key])
          can(edit, components[key])
        } else if (organizationComponentsList.includes(components[key])) {
          can(read, components[key])
          // As when subscription is not active, user should be able to edit organization subscription
          // So, they can activate subscription
          if (components[key] === organizationSubscription) {
            can(edit, components[key])
          }
        }
      })
    } else {
      Object.keys(components).forEach((key) => {
        // Check if the component is allowed or is an organization component
        const isAllowedModuleOrOrganizationComponent =
          allowedModules.includes(components[key]) ||
          organizationComponentsList.includes(components[key])

        if (
          isAllowedTo(anything, components[key]) &&
          isAllowedModuleOrOrganizationComponent
        ) {
          can(read, components[key])
          if (isAllowedTo(edit, components[key])) {
            can(edit, components[key])
          }

          // If user has access to anything on organization components
          if (
            organizationComponentsList.includes(components[key]) &&
            !doAnythingOnOrganizationComponents
          ) {
            doAnythingOnOrganizationComponents = true
          }
        }
      })
    }

    if (doAnythingOnOrganizationComponents) {
      can(anything, 'organizationComponents')
    }
  })

export { useAbility }
